import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { reviews } from "../../data/reviews";
import api from "../../lib/api";

export const Reviews = () => {
  const { t, lang } = useLanguage();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return (
    <section data-testid="reviews-section" className="py-20 sm:py-28 px-4 sm:px-6 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center max-w-xl mx-auto">
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-3 tracking-tight">{t("reviews.title")}</h2>
          <p className="text-white/60 text-base mb-4">{t("reviews.subtitle")}</p>
          {settings && (
            <div className="flex items-center justify-center gap-2 text-white/80">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold text-gold" />)}
              </div>
              <span className="text-sm">{settings.review_score.toFixed(1).replace(".", ",")} / 5 — {t("reviews.basedOn")}</span>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div key={r.id} data-testid={`review-card-${r.id}`} className="bg-[#141414] border border-white/5 rounded-xl p-6">
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-gold text-gold" />)}
              </div>
              <p className="text-white/80 text-sm leading-relaxed">&ldquo;{lang === "nl" ? r.nl : r.en}&rdquo;</p>
            </div>
          ))}
        </div>
        <p className="text-white/30 text-xs text-center mt-8">{t("reviews.source")}</p>
      </div>
    </section>
  );
};
